import { Global } from "@sourceflow-uk/sourceflow-sdk";
import { router } from "@/routes";
import sourceflowEnums from "@/sourceflow.enums";

export { default } from 'pages/submission-success'


/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
    const global = (await Global()).toJson();

    const routerKey = "get_started.thank_you";


    return {
        props: {
            global,
            meta: {
                title: `Thank you for submission | Tradewind Subs`,
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            }
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search